(function () {
  'use strict';

  angular.module('wsLrs.directives').
  /*
      provides the ability to disable options in a drop-down/select control 
      by setting a property value in the options array.
      
      example usage: 
          <select
              ng-model="selectedOption"
              ng-options="d as d.name for d in selectOptions track by d.name"
              ws-disable-select-options="selectOptions">
          </select>
      
      selectOptions is an array of select-option-properties objects for the select control.
      Any option that has a truthy 'disabled' property will be disabled. 
      For example,
       $scope.selectOptions = [
          {name: 'option_1'};                     // option is enabled
          {name: 'option_2', disabled: true},     // option is disabled
          {name: 'option_3', disabled: false}];   // option is enabled
  */

  directive('wsDisableSelectOptions', ['$timeout', function ($timeout) {
    return function (scope, element, attrs) {
      var ele = element;
      var optionPropertiesName = attrs.wsDisableSelectOptions;
      $timeout(function () {
        var optionProperties = ele.scope()[optionPropertiesName];
        var options = ele.children();
        if (optionProperties && options) {
          for (var i = 0; i < optionProperties.length; i++) {
            if (optionProperties[i].disabled) {
              options.eq(i).attr('disabled', 'disabled');
            }
          }
        }
      });
    };
  }]);
})();
